import * as q from '@/services/api/request/query';
import { InspectionStatus, Status, Type } from '@/entities/todo';
import { encodePaginatableQuery, PaginatableQuery, Query } from '../../request';
import { encodeSortableQuery, SortableQuery } from '@/services/api/request/query';

export interface InspectionQuery extends PaginatableQuery, SortableQuery {
  timezone: string;
  search: string;
  assignee: number[];
  doneBy: number[];
  entityItem: number[];
  status: Status[];
  approvalStatus?: number[];
  inspectionStatus?: InspectionStatus[] | null;
  doneAtStart?: Date | null;
  doneAtEnd?: Date | null;
  updatedAtStart?: Date | null;
  updatedAtEnd?: Date | null;
  categories: number[];
  overdue: boolean | null;
  questionTitle: string[];
  response: string[];
  type?: Type | null;
  dueAtStart?: Date | null;
  dueAtEnd?: Date | null;
  lazyPagination?: 0 | 1;
}

export const encodeInspectionQuery = (query: InspectionQuery): Query => ({
  ...encodePaginatableQuery(query),
  ...encodeSortableQuery(query),
  assignee: q.numericEnums(query.assignee),
  //on BE it filters by user/conductedBy
  user: q.numericEnums(query.doneBy),
  timezone: q.string(query.timezone),
  search: q.string(query.search),
  entityItem: q.numericEnums(query.entityItem),
  category: q.numericEnums(query.categories),
  status: q.numericEnums(query.status),
  approvalStatus: query.approvalStatus ? q.numericEnums(query.approvalStatus) : '',
  inspectionStatus: query.inspectionStatus ? q.numericEnums(query.inspectionStatus) : '',
  doneAtStart: q.nullableDate(query.doneAtStart || null),
  doneAtEnd: q.nullableDate(query.doneAtEnd || null),
  updatedAtStart: q.nullableDate(query.updatedAtStart || null),
  updatedAtEnd: q.nullableDate(query.updatedAtEnd || null),
  questionTitle: q.strings(query.questionTitle),
  response: q.strings(query.response),
  overdue: q.nullableBoolean(query.overdue),
  type: q.nullableString(query.type ? query.type.toString() : null),
  dueAtStart: q.nullableDate(query.dueAtStart || null),
  dueAtEnd: q.nullableDate(query.dueAtEnd || null),
  lazyPagination: q.nullableNumber(query.lazyPagination || 0),
});
